var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.833 10.5c0-.597-.227-1.194-.683-1.65a2.326 2.326 0 0 0-1.65-.683m0 9.333a7 7 0 1 0-6.937-6.059c.068.507.102.76.079.92a.996.996 0 0 1-.136.404c-.08.142-.219.281-.497.56l-5.962 5.962c-.202.201-.303.302-.375.42a1.167 1.167 0 0 0-.14.337c-.032.134-.032.277-.032.563v2.026c0 .654 0 .98.127 1.23.112.22.29.398.51.51.25.127.576.127 1.23.127h2.8v-2.333H10.5v-2.334h2.333l1.843-1.842c.278-.278.417-.418.559-.497a.996.996 0 0 1 .404-.136c.16-.023.413.011.92.08.307.04.622.062.941.062z",
    stroke: "#5786CC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.f4fcc733bbec7455bf460af849158714.svg";
export { ForwardRef as ReactComponent };